module.exports = __webpack_public_path__ + "img/Sugar2.a1f90c36.jpg";